import Cookies from 'js-cookie';

const TokenKey = 'token';
const RefreshTokenKey = 'refresh_token';
const CodeKey = 'code'; // 新增 Code 存储键
// 获取 Access Token
export function getToken() {
  return Cookies.get(TokenKey);
}

// 设置 Access Token
export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 7 }); // 7天有效期
}

// 获取 Refresh Token
export function getRefreshToken() {
  return Cookies.get(RefreshTokenKey);
}

// 设置 Refresh Token
export function setRefreshToken(token) {
  return Cookies.set(RefreshTokenKey, token, { expires: 7 });
}

// 获取 Code
export function getCode() {
  return Cookies.get(CodeKey);
}

// 设置 Code（仅本次登录有效）
export function setCode(code) {
  return Cookies.set(CodeKey, code, { expires: 1, sameSite: 'Lax' }); // 1天后过期
}

// 移除所有 Token
export function removeTokens() {
  Cookies.remove(TokenKey);
  Cookies.remove(RefreshTokenKey);
  Cookies.remove(CodeKey);
}